import { utilBuildings } from "../../../../../utils/utilBuildings";
import { createPathSelectBuildingMaxLevel } from "../../../path/createPathSelectBuildingMaxLevel";
import { selectAcresAvailable } from "../../../selectors/selectAcresAvailable";
export var pathSelectAcreProductionInProgressMaxLevelUseHumus = function (action, state$, deps) {
    return createPathSelectBuildingMaxLevel(function () {
        var acresAvailable = selectAcresAvailable(state$.value);
        return acresAvailable.filter(utilBuildings.isProducing);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/use-humus/paths/pathSelectAcreProductionInProgressMaxLevelUseHumus.ts
// module id = 2395
// module chunks = 3